module.exports = __webpack_public_path__ + "img/banner.97188793.png";